// extracted by mini-css-extract-plugin
module.exports =  {"alert":"VKBFsTj4gWzhAFtjKjc4"};